import axios from 'axios'
import config from '../config'
import router from '../router'
import store from '../store'

export function logoutUser (token) {
	const url = config.serverURI + '/token/tokenlogout?token=' + token
	console.log('Logging out user')
	axios.get(url)
		.then(response => {
			console.log('Response:', response)
			const message = response.data.message
			if (window.localStorage && message === 'Log out successful') {
				window.localStorage.setItem('user', null)
				window.localStorage.setItem('token', null)
				window.localStorage.setItem('refreshToken', null)
			}
			// Clear store state
			store.commit('SET_USER', null)
			store.commit('SET_TOKEN', null)
			console.log('redirecting')
			// Use router to prevent page reload
			router.push('/login')
		})
		.catch(error => {
			// Request failed - still clear storage and redirect
			console.log('error', error.response)
			if (window.localStorage) {
				window.localStorage.setItem('user', null)
				window.localStorage.setItem('token', null)
				window.localStorage.setItem('refreshToken', null)
			}
			store.commit('SET_USER', null)
			store.commit('SET_TOKEN', null)
			router.push('/login')
		})
}
